
import { Component, Vue, Watch, Prop, Mixins } from "vue-property-decorator";
import { Firearms, AROs, Documents, CRUDFunctionality } from "@/hooks";
import VuePdfApp from "vue-pdf-app";
import dayjs from "dayjs";
import {
  ArmResponseOfficer,
  Firearm,
  PsiraRegistrationDocuments,
  PsiraRegistrationDocuments_Create,
} from "models";
import { axiosInstance, axiosNoAuth } from "@/plugins/axios";
import Docs from "@/store/modules/Documents";
import FileMixin from "@/mixins/FileMixin.vue";
import logger from "@/plugins/logger";
import MultimediaViewer from "@/components/MultimediaViewer.vue";
import { Device } from "@capacitor/device";

interface Certificate {
  armResponseOfficerID: number;
  certificateFilesPath: string;
  certificates: string[];
  certificatesPath: string[] | null;
  createdBy: string;
  createdDate: string;
  firearmType: string;
  id: number;
  isTacticalUnitStandards: boolean;
  statementOfResultFilesPath: string;
  statements: string[];
  statementsPath: string[] | null;
  updatedBy: string;
  updatedDate: string;
  uploadDocument: boolean;
}

@Component({
  components: {
    VuePdfApp,
    MultimediaViewer,
  },
})
export default class BasicPus extends Mixins(FileMixin) {
  @Prop() certificate!: Certificate | null;
  @Prop() id!: number;
  valid = false;
  multiMediaViewer: { open: boolean; file: File | null } = {
    open: false,
    file: null,
  };
  // @Prop() handgun!: boolean;
  // @Prop() shotgun!: boolean;
  // @Prop() autoRifle!: boolean;
  // @Prop() selfLoadingRifle!: boolean;

  shouldDisplayForRole(name: string | undefined): boolean {
    const has = CRUDFunctionality.hasAccess(name);
    return !has;
  }

  viewMedia(file: File) {
    this.multiMediaViewer.file = file;
    this.multiMediaViewer.open = true;
  }
  /* get fileCheck(): boolean {
    if (
      this.newFiles.length > 0 ||
      this.newStatements.length > 0 ||
      this.statements.length > 0 ||
      this.certificates.length > 0
    ) {

    }
  } */

  get getSapsHG(): boolean {
    if (this.getAroDocs) {
      return (
        this.getAroDocs.sapsCompetencyCertificates.filter(
          (e) =>
            e.firearmType.includes("Handgun") &&
            e.isRegulation21Certificate == false
        ).length > 0
      );
    }
    return false;
  }
  get getSapsSG(): boolean {
    if (this.getAroDocs) {
      return (
        this.getAroDocs.sapsCompetencyCertificates.filter(
          (e) =>
            e.firearmType.includes("Shotgun") &&
            e.isRegulation21Certificate == false
        ).length > 0
      );
    }
    return false;
  }
  get getSapsSLR(): boolean {
    if (this.getAroDocs) {
      return (
        this.getAroDocs.sapsCompetencyCertificates.filter(
          (e) =>
            e.firearmType.includes("Self-Loading Rifle") &&
            e.isRegulation21Certificate == false
        ).length > 0
      );
    }
    return false;
  }

  get getSapsMOR(): boolean {
    if (this.getAroDocs) {
      return (
        this.getAroDocs.sapsCompetencyCertificates.filter(
          (e) =>
            e.firearmType.includes("Manually-Operated Rifle") &&
            e.isRegulation21Certificate == false
        ).length > 0
      );
    }
    return false;
  }

  get getOtherHandgun(): boolean {
    if (this.getAroDocs) {
      return (
        this.getAroDocs.basicProficiencyCertificates.filter(
          (e) =>
            e.isTacticalUnitStandards == false &&
            e != this.certificate &&
            e.firearmType.includes("Handgun")
        ).length != 0
      );
    } else return false;
  }

  get getOtherShotgun(): boolean {
    if (this.getAroDocs) {
      return (
        this.getAroDocs.basicProficiencyCertificates.filter(
          (e) =>
            e.isTacticalUnitStandards == false &&
            e != this.certificate &&
            e.firearmType.includes("Shotgun")
        ).length != 0
      );
    } else return false;
  }
  get getOtherManualRifle(): boolean {
    if (this.getAroDocs) {
      return (
        this.getAroDocs.basicProficiencyCertificates.filter(
          (e) =>
            e.isTacticalUnitStandards == false &&
            e != this.certificate &&
            e.firearmType.includes("Manually-Operated Rifle")
        ).length != 0
      );
    } else return false;
  }
  get getOtherSelfLoadingRifle(): boolean {
    if (this.getAroDocs) {
      return (
        this.getAroDocs.basicProficiencyCertificates.filter(
          (e) =>
            e.isTacticalUnitStandards == false &&
            e != this.certificate &&
            e.firearmType.includes("Self-Loading Rifle")
        ).length != 0
      );
    } else return false;
  }

  newFiles: File[] = [];
  newStatements: File[] = [];
  newCertExpanded = false;
  newStatementExpanded = false;

  currentDoc = {
    Handgun: false,
    Shotgun: false,
    Selfloadingrifle: false,
    Manuallyoperatedrifle: false,
    IsTacticalUnitStandards: false,
    BasicProficiencyCertificateID: 0,
    BasicProficiencyAROID: 0,
    UploadDocument: true,
    DeviceId: "",
  };
  fileToBeDeleted: {
    fileId: number;
    certPath: string;
    statePath: string;
  } | null = null;

  loading = false;
  // handgun = false;
  // shotgun = false;
  // selfLoadingRifle = false;
  // manuallyOperatedRifle = false;
  URL = URL;
  certificates: {
    preview: string;
    file: File | null;
    filePath: string;
    expanded: boolean;
    id: number;
  }[] = [];
  statements: {
    preview: string;
    file: File | null;
    filePath: string;
    expanded: boolean;
    id: number;
  }[] = [];
  errorHandler(e: any) {
    //   logger.log("Erroror", e);
  }

  deleteFile(certPath: string, statePath: string, index: number) {
    const fileId = this.currentDoc.BasicProficiencyCertificateID;
    this.fileToBeDeleted = {
      fileId: fileId,
      certPath: certPath,
      statePath: statePath,
    };

    if (certPath.length >= 1) {
      this.certificates.splice(index, 1);
    }

    if (statePath.length >= 1) {
      this.statements.splice(index, 1);
    }
  }

  async processDelete() {
    try {
      this.loading = true;
      if (this.fileToBeDeleted != null) {
        const res = await Documents.deleteBasicProficiency(
          this.fileToBeDeleted.fileId,
          this.fileToBeDeleted.statePath,
          this.fileToBeDeleted.certPath
        );

        this.fileToBeDeleted = null;
      }
      return Promise.resolve();
    } catch (err) {
      return Promise.reject(err);
    } finally {
      //this.$emit("refresh");
      this.loading = false;
    }
  }

  insertedStatements(arr: File[]): void {
    // logger.log("Testing inserting files trigger ", arr);
    if (arr.length > 0) {
      arr.forEach((f) => {
        const found = this.statements.findIndex((e) => e.file?.name == f.name);
        if (found == -1) {
          this.statements.push({
            preview: URL.createObjectURL(f),
            expanded: false,
            file: f,
            id: Math.random() * 100,
            filePath: "",
          });
        }
      });
      arr.splice(0);
    } else {
      this.statements.splice(0);
    }
  }
  insertedFiles(arr: File[]): void {
    //   logger.log("Testing inserting files trigger ", arr);
    if (arr.length > 0) {
      arr.forEach((f) => {
        const found = this.certificates.findIndex(
          (e) => e.file?.name == f.name
        );
        if (found == -1) {
          this.certificates.push({
            preview: URL.createObjectURL(f),
            expanded: false,
            file: f,
            id: Math.random() * 100,
            filePath: "",
          });
        }
      });
      arr.splice(0);
    } else {
      this.certificates.splice(0);
    }
  }
  async initCerts(): Promise<void> {
    const temp: Promise<File | null>[] = [];
    if (this.certificate != null && this.certificate.certificatesPath) {
      //   logger.log("Init Certs ------------:");
      this.certificate.certificatesPath.forEach((element: string) => {
        //   logger.log("Init a cert :", element);
        const that = Documents.getFile(element).catch((err) =>
          Promise.resolve(null)
        );
        if (that != null) temp.push(that);
      });
      const certArr = await Promise.all(temp);
      //   logger.log("Certs : ", certArr);
      const zip = (a: string[], b: (File | null)[]) =>
        a.map((v: string, i: number) => {
          return {
            file: b[i],
            path: v,
          };
        });
      const data = zip(this.certificate.certificatesPath, certArr);
      logger.log("data", data);
      this.certificates.splice(0);
      data.forEach((cert: { file: File | null; path: string }) => {
        if (cert) {
          this.certificates.push({
            preview: URL.createObjectURL(cert.file),
            expanded: false,
            file: cert.file,
            id: Math.random() * 100,
            filePath: cert.path,
          });
        }
      });
    } else {
      this.certificates.splice(0);
    }

    return Promise.resolve();
  }
  async initStatements(): Promise<void> {
    const temp: Promise<File | null>[] = [];
    if (this.certificate != null && this.certificate.statementsPath) {
      this.certificate.statementsPath.forEach((element: string) => {
        //   logger.log("Running for ", element);
        const that = Documents.getFile(element).catch((err) =>
          Promise.resolve(null)
        );
        if (that != null) temp.push(that);
      });
      const certArr = await Promise.all(temp);
      //   logger.log("Statements : ", certArr);
      const zip = (a: string[], b: (File | null)[]) =>
        a.map((v: string, i: number) => {
          return {
            file: b[i],
            path: v,
          };
        });
      const data = zip(this.certificate.statementsPath, certArr);
      logger.log("data", data);
      this.statements.splice(0);
      data.forEach((cert) => {
        if (cert) {
          this.statements.push({
            preview: URL.createObjectURL(cert.file),
            file: cert.file,
            expanded: false,
            id: Math.random() * 100,
            filePath: cert.path,
          });
        }
      });
    } else {
      this.statements.splice(0);
    }

    return Promise.resolve();
  }
  get getAroDocs() {
    return Docs.getAroDocs;
  }
  async init(): Promise<void> {
    try {
      //   logger.log("Init docs in BasicPus");
      this.loading = true;

      const deviceId = (await Device.getId()).uuid;
      const temp = [this.initCerts(), this.initStatements()];
      const res = await Promise.all(temp);

      if (this.getAroDocs != null) {
        if (this.certificate != null) {
          this.currentDoc.Handgun =
            this.certificate.firearmType.includes("Handgun");
          this.currentDoc.Shotgun =
            this.certificate.firearmType.includes("Shotgun");
          this.currentDoc.Selfloadingrifle =
            this.certificate.firearmType.includes("Self-Loading Rifle");
          this.currentDoc.Manuallyoperatedrifle =
            this.certificate.firearmType.includes("Manually-Operated Rifle");
          this.currentDoc.BasicProficiencyCertificateID = this.certificate.id;
          this.currentDoc.BasicProficiencyAROID =
            this.certificate.armResponseOfficerID;
          this.currentDoc.UploadDocument =
            this.certificate.uploadDocument != null
              ? this.certificate.uploadDocument
              : this.certificates.length > 0 || this.statements.length > 0
              ? true
              : false;
          this.currentDoc.DeviceId = deviceId;
        } else {
          this.currentDoc.Handgun = false;
          this.currentDoc.Shotgun = false;
          this.currentDoc.Selfloadingrifle = false;
          this.currentDoc.Manuallyoperatedrifle = false;
          this.currentDoc.IsTacticalUnitStandards = false;
          this.currentDoc.BasicProficiencyCertificateID = 0;
          this.currentDoc.BasicProficiencyAROID = this.getAroDocs.id;
          this.currentDoc.UploadDocument = true;
          this.currentDoc.DeviceId = deviceId;
        }

        this.fileToBeDeleted = null;

        //   logger.log("Results :", res);
        return Promise.resolve();
      }
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  }
  @Watch("certificate", {
    immediate: true,
  })
  async onCertificateChanged(val: Certificate): Promise<void> {
    //   logger.log("Certificate changed ! ---", val);
    await this.init();
  }
  async mounted(): Promise<void> {
    logger.log("----------- check boolean. : ", this.getOtherHandgun);
    await this.init();
  }
  async addBPUS(): Promise<void> {
    try {
      this.loading = true;
      if (this.currentDoc) {
        const formData = new FormData();
        Object.entries(this.currentDoc).forEach(([key, value]) => {
          if (typeof value === "boolean" || typeof value === "number") {
            formData.append(key, String(value));
          } else {
            formData.append(key, value);
          }
        });
        this.certificates.forEach((element, index) => {
          if (element.file != null) {
            formData.append("CertificateFiles", element.file);
            // tempCert.push(element.file);
          }
        });
        this.statements.forEach((element) => {
          if (element.file != null) {
            formData.append("StatementOfResultFiles", element.file);
            // tempState.push(element.file);
          }
        });
        //   logger.log("Form data ", formData.entries());

        await this.processDelete();
        const res = await axiosInstance.post(
          "/api/ManageDocumentsAPI/addBasicProficiency",
          formData
        );

        this.$emit("refresh");
        //   logger.log("Add Basic PUS response", res.data);
      }
    } catch (err) {
      return Promise.reject(err);
    } finally {
      this.loading = false;
    }
  }
  // @Watch("knowledgeOfAct", {
  //   immediate: true,
  // })
  // onKoaChanged(val: string | File | null, oldVal: string | File | null): void {
  ////   logger.log("Koa changed from ", oldVal, " to ", val);
  //   this.koaFile = val;
  // }
  // @Watch("statementOfResults", {
  //   immediate: true,
  // })
  // onSorChanged(val: string | File | null, oldVal: string | File | null): void {
  ////   logger.log("Sor changed from ", oldVal, " to ", val);
  //   this.sorFile = val;
  // }
}
